import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { HttpService } from '../services/http.service';

@Injectable()
export class InvestigationService {

  public sickLeave = null;

  constructor(public httpService: HttpService) {
  }

  getCertificatesForComparison(absenceid, employeeid) {
    const body = {
      'appLang': 'fr',
      'absenceid': absenceid,
      'employeeid': employeeid
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/sit/getcertificatecomparisionapi', body)
    return this.httpService.post('/hradmin/getCertificateComparision', body)
  }

  getPatternCount(absenceid, employeeid) {
    const body = {
      'appLang': 'fr',
      'absenceID': absenceid,
      'employeeID': employeeid
    };
    // return this.httpService.post('https://40n4ewvu2c.execute-api.eu-west-1.amazonaws.com/dev/getpatterncount', body)
    return this.httpService.post('/hradmin/getPatternCount', body)
  }
}


// WEBPACK FOOTER //
// ./src/app/services/investigation.service.ts